/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { getUsers } from "./fetch";
import {
  liveAgentChatSagaAction,
  chatpatient,
  shiftChatTopSagaAction,
  liveAgentChatCountAction,
} from "../../../../sagas/saga-actions";
import loginService from "../../../../service/login";
import { setPopup } from "../../../../actions/popupAction";
import {
  specialCharRegex,
  searchRegex,
  AGENT_TYPING,
} from "../../../../constants/constants";
import CommonService from "../../../../service/CommonService";

import { ErrorIcon } from "../../../../assets/svg";
import SidenavInner from "./sidenavInner";
import "./styles.scss";

const commonService = new CommonService();

const Sidenav = (props) => {
  const { chatPatient, handleChat, user, liveAgentChat, patients } = props;

  const numbersRef = useRef();
  const archiveAllRef = useRef();
  const wrapperRef = useRef(null);
  const userRef = useRef({});
  const customUser = props?.user;
  userRef.current = customUser;

  const [state, setState] = useState({
    activeTab: "1",
    page: 1,
    loadingPage: 0,
    isLoadingActive: false,
    hasMore: true,
    search: "",
    showAddNew: "",
    removeListPopup: false,
    showDropdown: false,
  });

  const loadMoreUsers = () => {
    const { page, loadingPage = 0, activeTab } = state;
    if (page >= 0 && loadingPage !== page) {
      const offset = page + 1;
      setState((st) => ({ ...st, isLoadingActive: true, loadingPage: page }));
      const activeArrayList = liveAgentChat?.chatList
        ? liveAgentChat.chatList
        : [];
      const tab = activeTab === "1" ? 1 : 0;
      getUsers(user.id, tab, offset, state.search)
        .then((response) => {
          if (response?.length > 0) {
            let newUsers = [...activeArrayList, ...response];
            newUsers = [...new Set(newUsers)];
            props.shiftChatTopSaga(newUsers);
            setState((st) => ({
              ...st,
              page: page + 1,
              isLoadingActive: false,
            }));
          } else {
            setState((st) => ({
              ...st,
              isLoadingActive: false,
              hasMore: false,
            }));
          }
        })
        .catch(() => {
          setState((st) => ({ ...st, isLoadingActive: false, hasMore: false }));
        });
    }
  };

  const updateMessageCount = (message) => {
    const user = userRef?.current;
    let tab = localStorage.getItem("tabSetAgent");

    if ((tab = "activeChat")) {
      tab = 1;
    } else if ((tab = "unClaimedChat")) {
      tab = 0;
    } else {
      tab = 2;
    }
    if (user?.id) {
      const obj = {
        offset: 0,
        active: tab,
      };
      if (
        !message?.textChat ||
        !message?.msg ||
        !message?.msg?.sendLinkMessage
      ) {
        setState((st) => ({ ...st, page: 1, hasMore: true, loadingPage: 0 }));
        if(numbersRef?.current?.scrollTo){
        numbersRef.current.scrollTo(0, 0);
        }
        props.liveAgentChatSaga(obj);
      }
    }
    if (message?.msg) {
      updateMessageCountWorker(message.msg.patientId);
    }
  };

  const isEmpty = (obj) => {
    for (let prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
    return true;
  };

  const updateMessageCountWorker = (chatId, setToZero) => {
    const { patient } = patients;
    let activeArrayList = [];
    if (liveAgentChat?.chatList?.length) {
      activeArrayList = liveAgentChat.chatList;
    } else {
      activeArrayList = liveAgentChat?.chatList ? [liveAgentChat.chatList] : [];
    }

    const existedChatIndex = activeArrayList.findIndex((u) => u.id === chatId);

    if (
      activeArrayList[existedChatIndex] &&
      isEmpty(patient) === false &&
      patient.id === activeArrayList[existedChatIndex].id
    ) {
      //nothing to do , please don't remove this comment
    } else {
      if (existedChatIndex > -1) {
        if (setToZero) {
          activeArrayList[existedChatIndex].count = 0;
        } else {
          activeArrayList[existedChatIndex].count =
            (activeArrayList[existedChatIndex].count || 0) + 1;
        }
        props.shiftChatTopSaga([...activeArrayList]);
      }
    }
  };

  const tabing = (tab, resetSearch = false, search = "") => {
    setState((st) => ({
      ...st,
      page: 1,
      loadingPage: 0,
      hasMore: true,
      activeTab: tab,
    }));

    resetSearch &&
      setState((st) => ({
        ...st,
        search: "",
        showAddNew: false,
      }));

    handleChat(false);

    chatPatient({});

    const filteredSearch = search.replace(/[^0-9a-z]/gi, "");
    let active;

    if (tab === "1") {
      localStorage.setItem("tabSetAgent", "activeChat");
      active = 1;
    } else if (tab === "2") {
      localStorage.setItem("tabSetAgent", "unClaimedChat");
      active = 0;
    } else if (tab === "3") {
      localStorage.setItem("tabSetAgent", "closedChat");
      active = 3;
    }
    const obj = {
      active,
      offset: 0,
      search: resetSearch ? "" : filteredSearch,
    };
    if (userRef?.current?.id) {
      props.liveAgentChatSaga(obj);
    }
    if (numbersRef?.current?.scrollTo) {
      numbersRef.current.scrollTo(0, 0);
    }
  };

  // set active user to active user listing
  const activateChatUser = (chatData) => {
    chatPatient(chatData);

    if (userRef?.current?.id) {
      updateMessageCountWorker(chatData.id, true);
      handleChat(true);
      props.getActivePatientNumber(chatData.id);
    }
  };

  // render chat list in liveAgent
  const listingLiveAgentChats = () => {
    const seletedChatId = patients?.patient?.id || "";

    if (liveAgentChat?.chatList?.length > 0) {
      const sortedChatList = liveAgentChat.chatList.sort(
        (a, b) =>
          new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
      );

      return (
        <>
          {sortedChatList.map((value, index) => {
            const { id, firstName, lastName, email, count } = value;
            if (id) {
              return (
                <li
                  className={`phone-number-item ${
                    seletedChatId === id ? "active-phone-number" : ""
                  }`}
                  key={index}
                  onClick={() => activateChatUser(value)}
                >
                  {firstName ? (
                    <article className="user-details-wrapper">
                      <p className="user-name">{`${firstName} ${lastName ||
                        ""}`}</p>

                      <p className="user-number">{email}</p>
                    </article>
                  ) : (
                    <article className="user-details-wrapper">
                      <p className="user-name">{email}</p>
                    </article>
                  )}
                  <div className="number-details">
                    <div className="msg-count orange">
                      {count !== 0 ? count : ""}
                    </div>
                  </div>
                </li>
              );
            }
            return null;
          })}
        </>
      );
    } else {
      return (
        <div className="side-tabs-empty">
          <ErrorIcon />
          <p className="error-message">No record found for active patients.</p>
        </div>
      );
    }
  };

  const handleSearch = (e) => {
    let search = e.target.value;
    const desiredSearch = search.replace(/[^0-9a-z\(\)-\s]/gi, "");
    const searchFormat = searchRegex.test(desiredSearch);
    if (!specialCharRegex.test(search)) {
      let showAddNew = searchFormat;

      setState((st) => ({ ...st, search, desiredSearch, showAddNew }));

      const currentTab = state.activeTab;
      let searchMethod = tabing;

      // set timeout so that the search waits while the user is typing
      setTimeout(() => {
        searchMethod(currentTab, false, search);
      }, 1000);
    }
  };

  const checkClear = (activeTab) => {
    if (activeTab.includes("1", "2")) {
      return false;
    } else if (liveAgentChat?.chatList?.length > 0 && activeTab === "3") {
      return true;
    } else {
      return false;
    }
  };
  const showTabsDropdown = () => {
    setState((st) => ({ ...st, showDropdown: !st.showDropdown }));
  };

  useEffect(() => {
    localStorage.setItem("tabSetAgent", "activeChat");

    // load active patients on load when user has logged in.
    if (numbersRef?.current?.scrollTo) {
      numbersRef.current.scrollTo(0, 0);
    }

    const user = loginService.getUser();
    if (user?.id) {
      const obj = {
        offset: 0,
        active: 1,
      };
      props.liveAgentChatSaga(obj);
    }
    props.liveAgentChatCountAction();

    window.addEventListener(
      "revokeChat",
      (e) => {
        tabing(`${state.activeTab}`);
      },
      false
    );
    window.addEventListener(
      "lcAgentReceiveMsg",
      (e) => {
        if (e.detail.msg.messageBody.startsWith(AGENT_TYPING) === false) {
          updateMessageCount(e.detail);
        }
      },
      false
    );

    window.addEventListener(
      "syncLivechatAgentClientsCount",
      (e) => {
        tabing(`${state.activeTab}`);
        props.liveAgentChatCountAction();
      },
      false
    );

    window.addEventListener(
      "refreshCurrentAgentTab",
      (e) => {
        tabing(`${state.activeTab}`);
      },
      false
    );

    return () => {
      window.removeEventListener("revokeChat", tabing("3"));
    };
  }, []);

  useEffect(
    () => {
      function handleClickOutside(event) {
        if (
          wrapperRef?.current &&
          !wrapperRef.current?.contains(event.target)
        ) {
          setState((st) => ({
            ...st,
            showDropdown: false,
          }));
        }
      }

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    },
    [wrapperRef]
  );

  const handleDropdown = () => {
    setState((st) => ({
      ...st,
      showDropdown: !st.showDropdown,
    }));
  };

  const handleSidebarClear = () => {
    setState((st) => ({ ...st, removeListPopup: true }));
  };

  const handleConfirmPopupClear = () => {
    setState((st) => ({ ...st, removeListPopup: false }));
  };

  const handleOnClear = async () => {
    if (!archiveAllRef.current) {
      archiveAllRef.current = true;
      try {
        const user = userRef?.current;
        const id = user?.id;
        await commonService.clearChatLiveAgent();

        props.setPopup({
          customPopupMessage: true,
          messageType: "success",
          message: "Closed chat list has been cleared successfully.",
        });
        setState((st) => ({ ...st, removeListPopup: false }));
        if (id) {
          const obj = {
            offset: 0,
            userId: id,
          };
          props.liveAgentChatSaga(obj);
        }
        props.liveAgentChatCountAction();
      } catch (e) {
        props.setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: "Something went wrong.",
        });
        setState((st) => ({ ...st, removeListPopup: false }));
      }

      archiveAllRef.current = false;
    }
  };

  return (
    <SidenavInner
      sidenavProps={props}
      sidenavState={state}
      showTabsDropdown={showTabsDropdown}
      tabing={tabing}
      wrapperRef={wrapperRef}
      handleDropdown={handleDropdown}
      handleSearch={handleSearch}
      handleSidebarClear={handleSidebarClear}
      numbersRef={numbersRef}
      loadMoreUsers={loadMoreUsers}
      listingLiveAgentChats={listingLiveAgentChats}
      checkClear={checkClear}
      handleConfirmPopupClear={handleConfirmPopupClear}
      handleOnClear={handleOnClear}
    />
  );
};

const mapStateToProps = (state) => ({
  patients: state.patients,
  user: state.login.user,
  popupReducer: state.popupReducer,
  liveAgentChat: state.liveAgentChat,
  liveAgentChatCount: state.liveAgentChatCount,
  unreadReducer: state.unreadReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    liveAgentChatSaga: bindActionCreators(liveAgentChatSagaAction, dispatch),
    chatPatient: bindActionCreators(chatpatient, dispatch),
    shiftChatTopSaga: bindActionCreators(shiftChatTopSagaAction, dispatch),
    liveAgentChatCountAction: bindActionCreators(
      liveAgentChatCountAction,
      dispatch
    ),
    setPopup: (data) => dispatch(setPopup(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sidenav);
